import { NgModule } from "@angular/core";

import { DynamicComponent } from "./dynamic.component";
import { CommonModule } from "@angular/common";import { CookieModule } from '../../../dynamic-module/cookie/cookie.module';
import { HeroPanelModule } from '../../../dynamic-module/hero-panel/hero-panel.module';
import { ArticleStartPanelModule } from '../../../dynamic-module/article-start-panel/article-start-panel.module';
import { ArticleContinuedPanelModule } from '../../../dynamic-module/article-continued-panel/article-continued-panel.module';
import { IconPanelModule } from '../../../dynamic-module/icon-panel/icon-panel.module';
import { FaqPanelModule } from '../../../dynamic-module/faq-panel/faq-panel.module';
import { SpotPanelModule } from '../../../dynamic-module/spot-panel/spot-panel.module';
import { ImagePanelModule } from '../../../dynamic-module/image-panel/image-panel.module';
import { VideoPanelModule } from '../../../dynamic-module/video-panel/video-panel.module';
import { QuotePanelModule } from '../../../dynamic-module/lib/panel/quote-panel/quote-panel.module';
import { AutosuggestPanelModule } from '../../../dynamic-module/autosuggest-panel/autosuggest-panel.module';
import { ContactPanelModule } from '../../../dynamic-module/contact-panel/contact-panel.module';
import { SubscribePanelModule } from '../../../dynamic-module/lib/panel/subscribe-panel/subscribe-panel.module';
import { NewsPanelModule } from '../../../dynamic-module/news-panel/news-panel.module';
import { TablePanelModule } from '../../../dynamic-module/table-panel/table-panel.module';
import { DocumentLibraryPanelModule } from '../../../dynamic-module/lib/panel/document-library-panel/document-library-panel.module';
import { LinksPanelModule } from '../../../dynamic-module/links-panel/links-panel.module';
import { TextPanelModule } from '../../../dynamic-module/text-panel/text-panel.module';
import { BoardHeroPanelModule } from '../../../dynamic-module/board-hero-panel/board-hero-panel.module';
import { TwoColumnsPanelModule } from '../../../dynamic-module/two-columns-panel/two-columns-panel.module';
import { BoardDemoPanelModule } from '../../../dynamic-module/board-demo-panel/board-demo-panel.module';
import { RtePanelModule } from '../../../dynamic-module/rte-panel/rte-panel.module';
import { TwoColTwoRowPanelModule } from '../../../dynamic-module/two-col-two-row-panel/two-col-two-row-panel.module';
import { BoardHeroVideoPanelModule } from '../../../dynamic-module/board-hero-video-panel/board-hero-video-panel.module';
import { PricesTablePanelModule } from '../../../dynamic-module/prices-table-panel/prices-table-panel.module';
import { OnboardingPanelModule } from '../../../dynamic-module/onboarding-panel/onboarding-panel.module';
import { ProfilesPanelModule } from '../../../dynamic-module/profiles-panel/profiles-panel.module';
import { VideoTestimonialsPanelModule } from '../../../dynamic-module/video-testimonials-panel/video-testimonials-panel.module';
import { CardGridPanelModule } from '../../../dynamic-module/card-grid-panel/card-grid-panel.module';
import { SecurityPanelModule } from '../../../dynamic-module/security-panel/security-panel.module';
import { ContactFormPanelModule } from '../../../dynamic-module/contact-form-panel/contact-form-panel.module';
import { GetMaterialsPanelModule } from '../../../dynamic-module/get-materials-panel/get-materials-panel.module';
import { DemoFormPanelModule } from '../../../dynamic-module/demo-form-panel/demo-form-panel.module';
import { MapsPanelModule } from '../../../dynamic-module/maps-panel/maps-panel.module';
import { ReferencesPanelModule } from '../../../dynamic-module/references-panel/references-panel.module';
import { AnimationCarouselPanelModule } from '../../../dynamic-module/animation-carousel-panel/animation-carousel-panel.module';
import { TestimonialsPanelModule } from '../../../dynamic-module/testimonials-panel/testimonials-panel.module';
import { LicensePanelModule } from '../../../dynamic-module/license-panel/license-panel.module';
import { InformationPanelModule } from '../../../dynamic-module/information-panel/information-panel.module';
import { MapPanelModule } from '../../../dynamic-module/map-panel/map-panel.module';
import { LicenseV2PanelModule } from '../../../dynamic-module/license-v2-panel/license-v2-panel.module';
import { UserGuidePanelModule } from '../../../dynamic-module/user-guide-panel/user-guide-panel.module';
import { FaqImagePanelModule } from '../../../dynamic-module/faq-image-panel/faq-image-panel.module';
import { InfoCardPanelModule } from '../../../dynamic-module/info-panel/info-card-panel.module';
import { VideoCarouselPanelModule } from '../../../dynamic-module/video-carousel-panel/video-carousel-panel.module';
import { BoardHeroDemoFormPanelModule } from '../../../dynamic-module/board-hero-demo-form-panel/board-hero-demo-form-panel.module';
import { DividerPanelModule } from '../../../dynamic-module/divider-panel/divider-panel.module';
import { LicenseV3PanelModule } from '../../../dynamic-module/license-v3-panel/license-v3-panel.module';
import { SidescrollingLogosPanelModule } from '../../../dynamic-module/sidescrolling-logos-panel/sidescrolling-logos-panel.module';


@NgModule({
  imports: [
    CommonModule,
    CookieModule,
    HeroPanelModule,
    ArticleStartPanelModule,
    ArticleContinuedPanelModule,
    IconPanelModule,
    FaqPanelModule,
    SpotPanelModule,
    ImagePanelModule,
    VideoPanelModule,
    QuotePanelModule,
    AutosuggestPanelModule,
    ContactPanelModule,
    SubscribePanelModule,
    NewsPanelModule,
    TablePanelModule,
    DocumentLibraryPanelModule,
    LinksPanelModule,
    TextPanelModule,
    BoardHeroPanelModule,
    TwoColumnsPanelModule,
    BoardDemoPanelModule,
    RtePanelModule,
    TwoColTwoRowPanelModule,
    BoardHeroVideoPanelModule,
    PricesTablePanelModule,
    OnboardingPanelModule,
    ProfilesPanelModule,
    VideoTestimonialsPanelModule,
    CardGridPanelModule,
    SecurityPanelModule,
    ContactFormPanelModule,
    GetMaterialsPanelModule,
    DemoFormPanelModule,
    MapsPanelModule,
    ReferencesPanelModule,
    AnimationCarouselPanelModule,
    TestimonialsPanelModule,
    LicensePanelModule,
    InformationPanelModule,
    MapPanelModule,
    LicenseV2PanelModule,
    UserGuidePanelModule,
    FaqImagePanelModule,
    InfoCardPanelModule,
    VideoCarouselPanelModule,
    BoardHeroDemoFormPanelModule,
    DividerPanelModule,
    LicenseV3PanelModule,
    SidescrollingLogosPanelModule,
  ],
  exports: [DynamicComponent],
  declarations: [DynamicComponent],
  providers: [],
})
export class DynamicModule {}
